export default {"src":"https://static.influitive.com/_next/static/media/addPicture.a4591e1b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};